/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dark_Fast_Snake_PullInputs */

const en_dark_fast_snake_pull = /** @type {(inputs: Dark_Fast_Snake_PullInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Address`)
};

const de_dark_fast_snake_pull = /** @type {(inputs: Dark_Fast_Snake_PullInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Adresse`)
};

/**
* | output |
* | --- |
* | "Address" |
*
* @param {Dark_Fast_Snake_PullInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const dark_fast_snake_pull = /** @type {((inputs?: Dark_Fast_Snake_PullInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dark_Fast_Snake_PullInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_dark_fast_snake_pull(inputs)
	return de_dark_fast_snake_pull(inputs)
});